<template>
  <v-dialog width="400px" v-model="showModal" persistent>
    <v-card>
      <v-card-title class="headline text-center">
        <strong>Editar recorrência</strong>
      </v-card-title>

      <v-card-text style="margin-top: 40px">
        <h6>Alteração do cartão</h6>
        <v-select
          style="margin-top: 40px"
          v-model="creditCardId"
          :items="creditCards"
          item-text="nickname"
          item-value="id"
          label="Selecione outro cartão"
        ></v-select>
      </v-card-text>

      <v-card-text>
        <h6>Migração de plano</h6>

        <v-select
          style="margin-top: 40px"
          v-model="promotionClientId"
          :items="plans"
          item-text="promotion.name"
          item-value="id"
          label="Escolha um plano para migrar"
          no-data-text="Sem planos recorrentes disponíveis"
        ></v-select>
      </v-card-text>

      <div
        style="width: 100%; padding: 0px 30px 0px 30px; margin-bottom: 30px"
        v-if="
          this.currentPromotionUser != null &&
          this.recurrent.promotion_id != this.currentPromotionUser.promotion_id
        "
      >
        <h6>MIGRAÇÃO REALIZADA!</h6>

        O plano vigente "{{
          this.currentPromotion && this.currentPromotion.name
        }}" irá expirar no dia
        {{
          this.currentPromotionUser &&
          dateHelper.formatDatetime(this.currentPromotionUser.expiration_date)
        }}
        e, depois, migrará para o plano "{{
          this.nextPromotion && this.nextPromotion.name
        }}".
      </div>

      <v-card-actions class="text-center align-center">
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" @click="hideModal"> Cancelar </v-btn>
        <v-btn
          color="green darken-1"
          @click="$emit('btnSim', creditCardId, promotionClientId)"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PromotionController from '../../controllers/PromotionController';
import PromotionClientController from '../../controllers/PromotionClientController';
import PromotionUserController from '../../controllers/PromotionUserController';
import UserCreditCardController from '../../controllers/UserCreditCardController';
import DateHelper from '../../helpers/DateHelper';

export default {
  props: {
    showModal: Boolean,
    recurrent: Object,
  },
  data() {
    return {
      userCreditCardController: new UserCreditCardController(this.$resource),
      promotionController: new PromotionController(this.$resource),
      promotionClientController: new PromotionClientController(this.$resource),
      promotionUserController: new PromotionUserController(this.$resource),
      dateHelper: DateHelper,
      creditCards: [],
      currentPromotionUser: null,
      nextPromotion: null,
      currentPromotion: null,
      plans: [],
      promotionClientId: null,
      creditCardId: null,
    };
  },

  watch: {
    recurrent: function () {
      this.getCurrentPromotionUser();
      this.getUserCreditCard();
      this.getPlansByClient();
    },
  },

  methods: {
    async getCurrentPromotionUser() {
      this.promotionUserController
        .getLastRecurrentPromotionActivationByUserId(this.recurrent.user.id)
        .then(async (res) => {
          this.currentPromotionUser = res.body;
          if (
            this.recurrent.promotion_id !=
            this.currentPromotionUser.promotion_id
          ) {
            this.nextPromotion = await this.promotionController.getById(
              this.recurrent.promotion_id
            );
            this.currentPromotion = await this.promotionController.getById(
              this.currentPromotionUser.promotion_id
            );
          }
        });
    },
    async getUserCreditCard() {
      this.creditCards = await this.userCreditCardController.getAllByUserId(
        this.recurrent.user.id,
        true
      );
    },
    async getPlansByClient() {
      this.plans = (
        await this.promotionClientController.getRecurrentByClientId(
          this.recurrent.client_id
        )
      ).body;

      this.plans = this.plans.filter((i) => {
        return i.promotion.id != this.recurrent.promotion_id;
      });
    },
    clearForm() {
      this.creditCardId = null;
      // this.creditCards = [];
      this.promotionClientId = null;
      // this.plans = [];
    },
    hideModal() {
      this.clearForm();
      this.$emit('btnNao');
    },
  },
};
</script>
